export default [{
  _name: 'CSidebarNav',
  _children: [
    {
      _name: 'CSidebarNavItem',
      name: 'Trang chủ',
      to: '/dashboard',
      icon: 'cil-home',
      roles: ['root', 'super', 'admin', 'user', 'viewer'],
    },
    {
      _name: 'CSidebarNavItem',
      name: 'Dự án',
      to: '/project/list',
      icon: 'cil-briefcase',
      roles: ['root', 'super', 'admin'],
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'Kho',
      route: '/component',
      icon: 'cil-storage',
      roles: ['root', 'super', 'admin', 'user', 'viewer'],
      items: [{
          name: 'Tìm kiếm',
          to: '/component/search',
          icon: 'cil-magnifying-glass',
          roles: ['root', 'super', 'admin', 'user', 'viewer'],
        },
        {
          name: 'Nhập/Xuất',
          to: '/component/add',
          icon: 'cil-input',
          roles: ['root', 'super', 'admin'],
        },
      ]
    },
    {
      _name: 'CSidebarNavItem',
      name: 'Cài đặt',
      to: '/setting',
      icon: 'cil-settings',
      roles: ['root'],
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'Quản lý',
      route: '/device',
      icon: 'cil-ethernet',
      roles: ['root', 'super', 'admin', 'user', 'monitor'],
      items: [
        {
          name: 'Kết nối',
          to: '/device/status',
          icon: 'cil-lan',
          roles: ['root', 'super', 'admin', 'user', 'monitor'],
        },
        {
          name: 'Sản phẩm',
          to: '/device/products',
          icon: 'cil-applications',
          roles: ['root', 'super', 'admin', 'user'],
        },
        {
          name: 'Giấy phép',
          to: '/device/license',
          icon: 'cil-lock-unlocked',
          roles: ['root', 'super'],
        },
        {
          name: 'Giao hàng',
          to: '/device/deliver',
          icon: 'cil-truck',
          roles: ['root', 'super', 'admin', 'user'],
        },
        {
          name: 'Bảo hành',
          to: '/device/guarantee',
          icon: 'cib-hackaday',
          roles: ['root', 'super', 'admin', 'user'],
        },
        {
          name: 'Khách hàng',
          to: '/device/customer',
          icon: 'cil-address-book',
          roles: ['root', 'super', 'admin'],
        },
        {
          name: 'Hợp đồng',
          to: '/device/contract',
          icon: 'cil-briefcase',
          roles: ['root', 'super'],
        }
      ]
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'Sản xuất',
      route: '/customer',
      icon: 'cil-briefcase',
      roles: ['root', 'super', 'admin', 'customer'],
      items: [
        {
          name: 'Theo dõi sản phẩm',
          to: '/customer/products',
          icon: 'cil-applications',
          roles: ['root', 'super', 'admin', 'customer'],
        },
        {
          name: 'Cập nhật tệp',
          to: '/customer/update',
          icon: 'cil-arrow-thick-to-bottom',
          roles: ['root', 'super', 'admin', 'customer'],
        },
        {
          name: 'Tạo mới',
          to: '/customer/create',
          icon: 'cil-pencil',
          roles: ['root', 'super', 'admin', 'customer'],
        },
        {
          name: 'Mới tạo',
          to: '/customer/new',
          icon: 'cil-short-text',
          roles: ['root', 'super', 'admin', 'customer'],
        },
        {
          name: 'Đã xác nhận',
          to: '/customer/confirm',
          icon: 'cil-save',
          roles: ['root', 'super', 'admin', 'customer'],
        },
        {
          name: 'Đang thực hiện',
          to: '/customer/running',
          icon: 'cil-running',
          roles: ['root', 'super', 'admin', 'customer'],
        },
        {
          name: 'Đã hoàn thành',
          to: '/customer/complete',
          icon: 'cil-task',
          roles: ['root', 'super', 'admin', 'customer'],
        },
        {
          name: 'Chậm tiến độ',
          to: '/customer/overdue',
          icon: 'cil-graph',
          roles: ['root', 'super', 'admin', 'customer'],
        },
        {
          name: 'Đã hủy',
          to: '/customer/cancel',
          icon: 'cil-action-undo',
          roles: ['root', 'super', 'admin', 'customer'],
        },
        {
          name: 'Toàn bộ',
          to: '/customer/list',
          icon: 'cil-applications',
          roles: ['root', 'super', 'admin', 'customer'],
        },
      ]
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'Tài khoản',
      route: '/user',
      icon: 'cil-contact',
      roles: ['root', 'super', 'admin', 'user', 'monitor', 'customer'],
      items: [
        {
          name: 'Mật khẩu',
          to: '/user/password',
          icon: 'cil-user',
          roles: ['root', 'super', 'admin', 'user', 'monitor', 'customer'],
        },
        {
          name: 'Danh sách',
          to: '/user/list',
          icon: 'cil-people',
          roles: ['root', 'super'],
        },
        {
          name: 'Đăng ký',
          to: '/user/register',
          icon: 'cil-user-follow',
          roles: ['root'],
        }
      ]
    },
    {
      _name: 'CSidebarNavItem',
      name: 'Giới thiệu',
      to: '/about',
      icon: 'cil-info',
      roles: ['root', 'super', 'admin', 'user', 'viewer'],
    },
  ]
}]
